class TestAiModelConnection {
	constructor(
		public readonly accountId: number,
		public readonly modelId: number,
		public readonly usage: string,
	) {
		Object.freeze(this);
	}

	// `usage` travels as a bare value, matching `AiUsage`'s raw-string entry shape on this endpoint.
	toJSON(): Record<string, unknown> {
		return {
			usage: this.usage,
		};
	}
}

export default TestAiModelConnection;
